import TemplateLandingPages from '../../TemplateLandingPages';

class SuccessStoriesList implements ng.IComponentController {
    storiesList: any[];

    constructor() {
        this.storiesList = TemplateLandingPages
            .filter(template => template.url.match(/\/success-stories\//))
            .map(story => {
                const companyInfoData: anm.LandingSectionCompanyInfo = _.first<any>(story.sections);
                return {
                    url: story.url,
                    bgImage: companyInfoData.background.imageUrl,
                    logo: companyInfoData.logoUrl,
                    description: companyInfoData.title
                }
            })
    }
}

angular.module('animatronApp.successStoriesList', []).component('successStoriesList', {
    controller: SuccessStoriesList,
    templateUrl: require('landing-template/components/success-stories-list.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/SuccessStoriesList.ts